<modal-container
  #modal
  [headerTitle]="('serialNumbers' | translate) + ': ' + productMove?.product?.name"
  [modalHeaderBgColorClass]="'bg_green'"
  [modalBodyBgColorClass]="'bg_green'"
  [modalFooterBgColorClass]="'bg_green'"
  [isLargeModal]="true"
>
  @if (!hideOpenButton) {
    <ng-container class="modal-button-show">
      <btn (onEvent)="showChildModal()" [icon]="'fa-regular fa-scanner-gun'" [title]="'open' | translate"></btn>
    </ng-container>
  }
  <ng-container class="modal-body-content">
    <div class="container-fluid ps-0 pe-0">
      <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
      @if (!loading) {
        <div class="card" style="padding: 26px">
          <div class="font-weight-bold">
            {{ ('serialNumbers' | translate) + ':' }}
          </div>
          <div class="container-serial-numbers">
            @for (serialNumber of productMove.serialNumbers; track serialNumber) {
              <div class="serial-number-div">
                <span>{{ serialNumber }}</span>
                <span class="ng-value-icon right" (click)="removeSerialNumber(serialNumber)" aria-hidden="true">×</span>
              </div>
            }
          </div>
          <div>
            <div class="d-flex">
              <form-row-textarea
                class="w-50"
                [icon]="'far-note'"
                [label]="'serialNumbers.addNew'"
                [placeholder]="'type.here'"
                [classes]="['height-8rem']"
                [dataCyAttribute]="'serial-numbers-input'"
                (keydown)="keyPressed($event)"
                [(model)]="serialNumbersInString"
              >
              </form-row-textarea>
              <div class="d-flex align-items-end w-50 font-italic">
                <div class="text-padding">
                  {{ 'serialNumbers.you.can.add.more.numbers' | translate }}
                </div>
                <div></div>
              </div>
            </div>
            <btn
              class="margin-left-13-5"
              [label]="'add'"
              [title]="'add' | translate"
              (click)="addSerialNumbers()"
              [classes]="['btn-third-grey']"
              [dataCyAttribute]="'serial-numbers-add'"
              [isLoading]="loading"
              [spinnerClassesString]="'spinner-white'"
            >
            </btn>
          </div>
        </div>
      }
    </div>
  </ng-container>
  @if (!loading) {
    <ng-container class="modal-footer-content">
      <div class="serialNumberAmountFromQuantity">
        {{
          ('product.qty' | translate) +
            ': ' +
            productMove.serialNumbers.length +
            ' z ' +
            (productMove.amount | number: '1.0-2')
        }}
      </div>
      <btn
        [label]="'serialNumbers.set'"
        [title]="'serialNumbers.set'"
        [btnType]="'submit'"
        (onEvent)="setSerialNumbers()"
        [classes]="['btn-first']"
        [dataCyAttribute]="'serial-numbers-submit'"
      >
      </btn>
    </ng-container>
  }
</modal-container>
